import { Main } from './main';
import { LayoutSection } from '../core/layout-section';
import { cn } from '@/lib/utils';
import { LanguagePopover } from '../components/language-popover';

// ----------------------------------------------------------------------

export type AuthLayoutProps = {
  className?: string;
  children: React.ReactNode;
  header?: {
    className?: string;
  };
};

export function AuthLayout({ className, children, header }: AuthLayoutProps) {
  return (
    <LayoutSection
      headerSection={null}
      footerSection={null}
      cssVars={{
        '--layout-nav-vertical-width': '0px',
      }}
      className={cn(
        'relative h-screen w-screen overflow-hidden',
        "before:fixed before:inset-0 before:-z-10 before:bg-cover before:bg-center before:bg-no-repeat before:opacity-[0.24] before:content-[''] dark:before:opacity-[0.08]",
        "before:bg-[url('/assets/background/overlay.jpg')]",
        className,
      )}
    >
      <div className="fixed right-4 top-4 z-[1000]">
        <LanguagePopover className="border border-border bg-background/90 shadow-sm backdrop-blur" />
      </div>
      <Main>{children}</Main>
    </LayoutSection>
  );
}
